export const FUNCTIONS = [
  {
    icon: 'tw:i-fal-scroll',
    label: 'Write a script',
  },
  {
    icon: 'tw:i-fal-list-check',
    label: 'Create a task',
  },
  {
    icon: 'tw:i-fal-address-book',
    label: 'Add a contact',
  },
  {
    icon: 'tw:i-fal-dollar-sign',
    label: 'Create a deal',
  },
]
